import { Injectable } from "@angular/core";
import { idField, ReferenceField } from "@common/references/reference-field";
import { User } from "./users.interfaces";
import { DefaultService } from "@common/references/default.service";
import urlJoin from "url-join";
import { environment } from "@environments/environment";
import { UserFormComponent } from '@modules/settings/users/user-form/user-form.component';
import { TranslateRolePipe } from '@common/pipe/translateRole.pipe';

@Injectable({
  providedIn: "root",
})
export class UsersService extends DefaultService<User> {
  backendName = 'users';
  formComponent = UserFormComponent;
  title = 'MENU.USERS';
  titleSingular = 'USERS';
  translateRolePipe = new TranslateRolePipe()

  fields: ReferenceField[] = [
    idField,
    {fieldName: 'firstName', label: 'USERS.FIRSTNAME', iconClass: 'las la-user', filter: true},
    {fieldName: 'lastName', label: 'USERS.LASTNAME', iconClass: 'las la-user', filter: true},
    {fieldName: 'userName', label: 'USERS.USERNAME', iconClass: 'las la-id-badge', filter: true},
    {
      fieldName: 'roles',
      label: 'USERS.ROLE',
      fieldValue: (value) => this.translateRolePipe.transform(value),
      iconClass: 'las la-user-tag',
      filter: true
    },
    {fieldName: 'email', label: 'USERS.EMAIL', iconClass: 'las la-envelope', filter: true},
    {fieldName: 'phoneNumber', label: 'USERS.PHONENUMBER', iconClass: 'las la-phone', filter: true},
    {
      fieldName: 'status',
      label: 'USERS.STATUS',
      viewType: 'status',
      iconClass: 'las la-toggle-on',
      filter: {type: "boolean"}
    },
  ];
  formModalOptions = {
    size: 'lg',
    scrollable: false
  }
  hasActions = true;
  hasAdd = true;
  hasDelete = true;
  hasEdit = true;
  hasView = false

  updateProfile(form: any) {
    return this._http.put(urlJoin(this.getUrl(), 'edit/profile'), form)
  }

  getUrl(): string {
    return urlJoin(environment.apiUrl, 'users');
  }
}
